module.exports = __webpack_public_path__ + "static/media/needs-4-outline.e9e8f1b7.png";